'use client'

// Third-party Imports
import classnames from 'classnames'

// Component Imports

import ModeDropdownWhite from '@components/layout/shared/ModeDropdownWhite'
import UserDropdownWhite from '@components/layout/shared/UserDropdownWhite'

// Util Imports
import { verticalLayoutClasses } from '@layouts/utils/layoutClasses'

const NavbarContent = ({ dataSession }: { dataSession: any }) => {
  return (
    <div
      className={classnames(
        verticalLayoutClasses.navbarContent,
        'flex items-center justify-between gap-4 is-full bacround mr-2 ml-2'
      )}
    >
      <div className='flex items-center gap-4'>
        <ModeDropdownWhite dataSession={dataSession} />
      </div>
      <div className='flex items-center'>
        <UserDropdownWhite dataSession={dataSession} />
      </div>
    </div>
  )
}

export default NavbarContent
